import { FC } from 'react';
import { NudgeBanner } from '../../components/NudgeBanner';

export type IEditPatientNudgeBannerProps = {
    patient: any;
    canEdit: boolean;
    excludeDOB?: boolean;
    onEdit: () => void;
};

export const EditPatientNudgeBanner: FC<IEditPatientNudgeBannerProps> = ({ patient, canEdit, onEdit, excludeDOB }) => {
    const showEditNudgeBadge = canEdit && !patient.diagnoses?.length &&
        !patient.allergies?.length && !patient.contactMethods.length && !patient.address &&
        (excludeDOB || !patient.dob);

    if (!canEdit) {
        return;
    }

    return showEditNudgeBadge &&
        <NudgeBanner
            buttonLabel="Edit"
            buttonClickHandler={onEdit}
            message={`Enhance this care profile with address, contact info${!excludeDOB ? ', DOB' : ''} and diagnoses`}
        />;
};
